export class JsonReader {
  protected jsonFilePath:string;

  public jsonFileContent:any;

  constructor(filePath:string) {
    this.jsonFilePath = filePath;
  }

  private readJSON(jsonFilePath:string) {
    return fetch(jsonFilePath)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to fetch JSON file: ${response.status} ${response.statusText}`);
        }
        return response.json();
      }
    );
  }

  // Start -- Custom methods --
  public getContents(type = '') {
    return this.readJSON(this.jsonFilePath)
      .then(jsonData => {
        let ret:any;

        if (type == 'data') {
          ret = jsonData.data;
          ret.sort( (a:any, b:any) => (
            a.name > b.name ? 1 : -1
          ));
        } else if (type == 'category') {
          return jsonData.category;
        } else if (type == 'character') {
          return jsonData.character_tag;
        } else {
          ret = jsonData;
        }

        return ret;
      })
      .catch(error => {
        console.error('Error:', error);
      })
    ;
  }

  public getByCategory(category:string) {
    return this.readJSON(this.jsonFilePath)
      .then(jsonData => {
        let jsonDataList = jsonData.data;
        let ret = [] as any;
        
        if (category == '') {
          return ret;
        } else if (category == 'all') {
          category = jsonData.category[0].name;
        }

        jsonDataList.forEach( (element:any) => {
          if (element.tags && element.tags.length > 0) {
            element.tags = this.mapArrays(element.tags, jsonData.tags, 'id');
          }
          if (element.familyname == category && (element.familyname_nodisplay == false || element.familyname_nodisplay == undefined)) {
            let elemObj = element;
            ret.push(elemObj);
          }
        });

        return ret;
      })
      .catch(error => {
        console.error('Error:', error);
      })
    ;
  }

  public searchByName(name:string) {
    return this.readJSON(this.jsonFilePath)
      .then(jsonData => {
        let jsonDataList = jsonData.data;
        let ret = [] as any;
        
        jsonDataList.forEach( (element:any) => {
          if (element.search_nodisplay == false || element.search_nodisplay == undefined) {
            if (element.name.includes(name)) {
              ret.push(element);
            }
            if ( (element.searchalias != null && element.searchalias != '')) {
              if (element.searchalias.includes(name)) {
                ret.push(element);
              }
            }
          }
        });

        ret.sort( (a:any, b:any) => (
          a.name > b.name ? 1 : -1
        ));

        return ret;
      })
      .catch(error => {
        console.error('Error:', error);
      })
    ;
  }

  public getByCharacter(character:string) {
    return this.readJSON(this.jsonFilePath)
      .then(jsonData => {
        let jsonDataList = jsonData.data;
        let ret = [] as any;

        if ( character == '' ) {
          character = jsonData.character_tag[0].character;
        }

        jsonDataList.forEach( (element:any) => {
          if (element.character_tag != null && element.character_tag.length > 0) {
            element.character_tag.forEach( (charItem:any) => {
              if (charItem == character) {
                let elemObj = element;
                ret.push(elemObj);
              }
            });
          }
        });

        ret.sort( (a:any, b:any) => (
          a.name > b.name ? 1 : -1
        ));

        return ret;
      })
      .catch(error => {
        console.error('Error:', error);
      })
    ;
  }

  private mapArrays(arr1:any, arr2:any, key:any) {
    // Create a map for faster lookups
    const map = new Map();
    arr2.forEach((element:any) => {
      map.set(element[key], element);
    });
  
    // Use the map function to join elements from arr1 and arr2 based on the key
    const joinedArray = arr1.map((element1:any) => {
      const element2 = map.get(element1);
      if (element2) {
        // Combine the objects from arr1 and arr2
        return { ...element1, ...element2 };
      } else {
        // Handle cases where no matching element is found in arr2
        return element1;
      }
    });
  
    return joinedArray;
  }
  // End -- Custom methods --
}
